﻿import $ from 'jquery';
import { ErrorPopover } from "./errorpopover";
import { FormValidation, IValidationHandler } from "./formvalidation";
import { FieldValidationHandler } from "./fieldvalidationhandler";


export class PhoneValidationHandler implements IValidationHandler {
  handle($error: JQuery): boolean {
    var $phoneField = $error.closest('.phone-field');
    var isPhone = $phoneField.length > 0;
    if (isPhone == false)
      return false;

    if ($phoneField.data('error-handled') == true)
      return true;

    var $errors = $phoneField.find('.field-validation-error')
    var $errorRollUp = $('<div class="error-rollup">');
    $errors.each(function () {
      var $error = $(this);
      $errorRollUp.append($('<p>').append($error.html()));
      new FieldValidationHandler().handle($error);
    });

    var $targetInput = $phoneField.find('.phone-full-input');
    var targetId = $errors.first().data('for') + '-phone-full-input';
    new ErrorPopover().append($targetInput, targetId, $errorRollUp);
    $phoneField.data('error-handled', true);

    return true;
  }
}
